import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsKudoHighlightedXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M15.17 6.543c.08.204.117.423.11.642-.019.4-.19.776-.477 1.053a1.616 1.616 0 01-.07 1.497 1.595 1.595 0 01-.603.587l-.109 1.541a1.775 1.775 0 01-1.77 1.64H6.934l-2.29-5.96.434-.227 2.128-4.103L7.899.51h.098a2.104 2.104 0 011.975 2.095c0 .102-.01.204-.032.304l-.651 2.605h4.341a1.62 1.62 0 011.54 1.029zM.41 9.8l3.202-1.704.065-.033 2.29 5.948L2.7 15.76.41 9.801z"
        fill=""
      />
    </svg>
  )
);
SvgActionsKudoHighlightedXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgActionsKudoHighlightedXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActionsKudoHighlightedXsmall;
